var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchloadTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3399 0H4.36364V2.18182H10.3399V0ZM24 19.6364H21.8182V13.6601H24V19.6364ZM24 12.8063H21.8182V6.83004H24V12.8063ZM24 5.97628H21.8182V2.18182H18.0237V0H24V5.97628ZM17.17 0V2.18182H11.1937V0H17.17ZM1.09091 3.27273H7.06719V5.45455H1.09091V3.27273ZM18.5455 22.9091H20.7273V16.9328H18.5455V22.9091ZM18.5455 16.0791H20.7273V10.1028H18.5455V16.0791ZM18.5455 9.24901H20.7273V3.27273H14.751V5.45455H18.5455V9.24901ZM13.8972 5.45455V3.27273H7.92095V5.45455H13.8972ZM5.31225 6.54545H0V11.8577H5.31225V6.54545ZM11.3834 6.54545H6.07115V11.8577H11.3834V6.54545ZM12.1423 6.54545H17.4545V11.8577H12.1423V6.54545ZM5.31225 12.6166H0V17.9289H5.31225V12.6166ZM6.07115 12.6166H11.3834V17.9289H6.07115V12.6166ZM17.4545 12.6166H12.1423V17.9289H17.4545V12.6166ZM0 18.6877H5.31225V24H0V18.6877ZM11.3834 18.6877H6.07115V24H11.3834V18.6877ZM12.1423 18.6877H17.4545V24H12.1423V18.6877Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchloadTask);
export default __webpack_public_path__ + "static/media/BatchloadTask.70316fcdf8f7ca21d3d9948820cea096.svg";
export { ForwardRef as ReactComponent };